import React from 'react'

export default function FaceFeature({ scale, scaleX, outline, verticalOffset }) {
  const transformOrigin = '11.38 5.84'
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g transform={`scale(${scale},${scale})`} transform-origin={transformOrigin}>
        <path
          d="M21.1001 0.860107C21.1001 0.860107 17.6501 2.29011 11.3701 2.29011C5.09014 2.29011 1.64014 0.860107 1.64014 0.860107C5.21014 8.53011 9.08014 9.97011 11.3601 9.97011C13.6401 9.97011 17.5301 8.53011 21.1001 0.860107Z"
          fill="white"
        />
        <path
          d="M11.37 11.68C4.01 11.68 0 0 0 0C0 0 5.37 1.27 11.38 1.27C17.39 1.27 22.76 0 22.76 0C22.76 0 18.72 11.68 11.37 11.68ZM2.7 2.22C5.92 8.19 9.66 9.14 11.36 9.14C13.06 9.14 16.85 8.19 20.07 2.22C18.39 2.64 15.07 3.12 11.37 3.12C7.67 3.12 4.38 2.64 2.7 2.22Z"
          fill={outline}
        />
        <path d="M7.1701 3.94995H5.3501V5.76995H7.1701V3.94995Z" fill="#B2B2B2" />
        <path d="M10.5803 3.94995H8.76025V5.76995H10.5803V3.94995Z" fill="#B2B2B2" />
        <path d="M13.9899 3.94995H12.1699V5.76995H13.9899V3.94995Z" fill="#B2B2B2" />
        <path d="M17.4001 3.94995H15.5801V5.76995H17.4001V3.94995Z" fill="#B2B2B2" />
        <path
          d="M4.39014 4.81982H18.3501"
          stroke="#B2B2B2"
          strokeWidth="0.25"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
    </g>
  )
}
